import { p2, p3 } from '@repo/ui/components/Typography';
import { QUERIES } from '@repo/ui/queries';
import styled from 'styled-components';

export const NotifyText = styled.div`
  ${p3};
  padding-right: 8px;

  ${QUERIES.largeTabletAndUp} {
    ${p2};
  }
`;
